const ContactData = [
    {
        phone: 13514442871,
        email: 'andresaaramirez730@gmail.com',
        website: 'https://github.com/ARam2142',
        linkedin: 'https://www.linkedin.com/in/andres-ramirez-8b07487b/',
        resume: 'https://drive.google.com/file/d/1VBcI0io6YjjRP_pwa7Z66E2FSxpM9wfi/view?usp=sharing'
    }
];
console.log(ContactData)

export default ContactData;